// extracted by mini-css-extract-plugin
module.exports = {"paginatorWrap":"Paginator_paginatorWrap__3ZIU8","pageList":"Paginator_pageList__5WS8X","selectedPage":"Paginator_selectedPage__WGYll","disabled":"Paginator_disabled__17zpO"};